import {
  createFileRoute,
  notFound,
  redirect,
  stripSearchParams,
} from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import jwtDecode from 'jwt-decode';
import { queryEntepriseOrgSettings } from 'src/api/queries/enterpriseAdmin';
import type { RmClaims } from 'src/api/queries/user';
import { EnterPriseDomainsPage } from 'src/apps/fleet/app/pages/EnterpriseDomainsPage';
import { authHelpers } from 'src/utils/authHelpers';
import { AccessDeniedError } from 'src/utils/errors';
import { userHelpers } from 'src/utils/userHelpers';
import { z } from 'zod';

const defaultValues = {
  filter: '',
};

const routeSearchSchema = z.object({
  filter: z.string().default(defaultValues.filter),
});

export const Route = createFileRoute(
  '/_auth/enterprise/_with-org/_layout/domains'
)({
  validateSearch: zodValidator(routeSearchSchema),
  search: { middlewares: [stripSearchParams(defaultValues)] },
  async beforeLoad({ context }) {
    const auth = await context.auth;

    if (!auth.user) {
      throw redirect({ to: '/login' });
    }
    if (!context.featureFlags.EnableEnterpriseDomainsPage) {
      throw notFound();
    }

    const accessToken = await authHelpers.getAccessTokenSilently(auth);
    const claims = jwtDecode<RmClaims>(accessToken);

    if (!userHelpers.hasPermissionReadMembers(claims)) {
      throw new AccessDeniedError(
        'You do not have permission to view this page. Please contact your IT admin to request access.'
      );
    }
  },
  loader({ context }) {
    void context.queryClient.ensureQueryData(queryEntepriseOrgSettings());
  },
  component: () => <EnterPriseDomainsPage />,
});
